import * as TablerIcons from '@tabler/icons-react';
import type { IconProps, TablerIcon } from '@tabler/icons-react';
import type { SVGProps } from 'react';
import { CUSTOM_ICONS } from '@/types';
import styles from './Icon.module.sass';
import ChartSimpleIcon from '@/assets/icons/chart-simple-solid.svg?react';
import ChurchIcon from '@/assets/icons/church-solid.svg?react';
import CommentsDotsIcon from '@/assets/icons/comment-dots-solid.svg?react';
import DioceseBuildingIcon from '@/assets/icons/building-solid.svg?react';
import AdorationIcon from '@/assets/icons/adoration.svg?react';
import CaminoIcon from '@/assets/icons/camino.svg?react';
import MyParishIcon from '@/assets/icons/my-parish.svg?react';
import FacilitiesIcon from '@/assets/icons/facilities.svg?react';
import MassIntentionsIcon from '@/assets/icons/intentions.svg?react';
import MinistriesIcon from '@/assets/icons/ministries.svg?react';
import FormsIcon from '@/assets/icons/forms.svg?react';
import MessagesIcon from '@/assets/icons/messages.svg?react';

// Custom icons map
const customIconMap = {
  [CUSTOM_ICONS.CHURCH_SOLID]: ChurchIcon,
  [CUSTOM_ICONS.COMMENTS_DOT]: CommentsDotsIcon,
  [CUSTOM_ICONS.CHART_SIMPLE]: ChartSimpleIcon,
  [CUSTOM_ICONS.DIOCESE_BUILDING_SOLID]: DioceseBuildingIcon,
  [CUSTOM_ICONS.ADORATION]: AdorationIcon,
  [CUSTOM_ICONS.CAMINO]: CaminoIcon,
  [CUSTOM_ICONS.MY_PARISH]: MyParishIcon,
  [CUSTOM_ICONS.FACILITIES]: FacilitiesIcon,
  [CUSTOM_ICONS.MASS_INTENTIONS]: MassIntentionsIcon,
  [CUSTOM_ICONS.MINISTRIES]: MinistriesIcon,
  [CUSTOM_ICONS.FORMS]: FormsIcon,
  [CUSTOM_ICONS.MESSAGES]: MessagesIcon,
} as const;

type TablerIconName = keyof typeof TablerIcons;
type CustomIconName = keyof typeof customIconMap;
type IconComponentProps = {
  name: IconName;
  className?: string;
  size?: number | string;
} & Omit<IconProps & SVGProps<SVGSVGElement>, 'ref' | 'className' | 'size'>;

export type IconName = TablerIconName | CustomIconName;

export const Icon = ({ name, className, size, ...props }: IconComponentProps) => {
  if (name in customIconMap) {
    const IconComponent = customIconMap[name as CustomIconName];
    const svgProps = {
      ...props,
      className: `${styles.icon} ${className || ''}`,
      ...(size && { width: size, height: size }),
    };
    return <IconComponent {...svgProps} />;
  }

  const IconComponent = (TablerIcons as unknown as Record<string, TablerIcon>)[name] || null;

  if (!IconComponent) {
    console.warn(`Icon "${name}" not found`);
    return null;
  }

  const svgProps = {
    ...props,
    className: `${styles.icon} ${className || ''}`,
    ...(size && { width: size, height: size }),
  };

  return <IconComponent {...svgProps} />;
};
